module.exports = __webpack_public_path__ + "static/media/ticTacToe.de1bcd00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ticTacToe.jpg
// module id = 80
// module chunks = 0